/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import emptyImages from 'assets/img/empty-images.svg';
import {connect} from 'react-redux';
import { isEmpty } from 'lodash';
import word from 'assets/img/file_word.png';
import excel from 'assets/img/file_excel.png';
import pdf from 'assets/img/file_pdf.png';
import ppt from 'assets/img/file_pp.png';
import video from 'assets/img/file_video.png';
import other from 'assets/img/file_other.png';
import {isMobile} from 'react-device-detect';
import PreviewVideoWO from '../../../Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
import Linkify from 'react-linkify';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Moment from 'moment';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import * as validator from 'helper/validator-helper';
import DatePicker from 'components/react-validation/components/datepicker';
import TagsInputs from 'components/react-validation/components/tags-input';
import Input from 'components/react-validation/components/input';
import {isNull} from 'lodash';
import * as LotActionType from '../../constants';
const TAGS_LIST = [9, 13, 188];
class EditCategoryItemsLot extends React.Component {
    static propTypes = {
      dispatch: PropTypes.func,
      lot: PropTypes.string,
      onGetCategoryItemProfile: PropTypes.func,
      location: PropTypes.any,
      history: PropTypes.any,
      categoryItemProfile: PropTypes.object,
      categoryList: PropTypes.array,
      goToViewScreen: PropTypes.func,
      goToListScreen: PropTypes.func,
      categoryItemId: PropTypes.string
    }
    constructor(props) {
      super(props);
      this.state = {
        purchaseDate: null,
        category: null,
        cancelUploadList: {},
        deleteUploadList: {},
        imagePreview: null,
        showDialog: false
      };
    }

    componentDidMount() {
      this.props.onGetCategoryItemProfile(this.props.categoryItemId);
    }

    onTogglePreviewImages = (url) => {
      this.setState({
        imagePreview: url
      });
    }

    onPreviewFilesAttachment = (file) => {
      const extension = file.fileName.split('.').pop().toLowerCase();
      const imageType = ['jpg', 'jpeg', 'png', 'gif'];
      const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
      if (imageType.includes(extension)) {
        this.setState({
          show: true,
          previewUrl: file.url
        });
      }
      if (extension === 'pdf') {
        this.setState({
          isPreviewPDF: file.url
        }, () => {
          if (isMobile) {
            window.open(this.state.isPreviewPDF, '_blank');
          }
        });
      }
      if (videoType.includes(extension)) {
        this.setState({
          showDialog: true,
          videoUrl: file.url
        });
      }
    }

    handleClose = () => {
      this.setState({ show: false, previewUrl: null});
    }

    handleCloseVideo = (callback) => {
      this.setState({ showDialog: false, videoUrl: null}, callback);
    }

    renderFileTypeIcon = (item) => {
      const extWord = ['doc', 'docx'];
      const extExcel = ['xls', 'xlsx'];
      const extPpt = ['ppt', 'pptx'];
      const extImage = ['jpg', 'jpeg', 'png', 'gif'];
      const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
      const ext = item.fileName.split('.').pop().toLowerCase();
      if (extWord.includes(ext)) {return word;}
      else if (extExcel.includes(ext)) {return excel;}
      else if (extPpt.includes(ext)) {return ppt;}
      else if (extPpt.includes(ext)) {return ppt;}
      else if (extVideo.includes(ext)) {return video;}
      else if (ext === 'pdf') {return pdf;}
      else if (extImage.includes(ext)) {return item.url;}
      else {return other;}
    }

    renderFileUpload = () => {
      const { categoryItemProfile} = this.props;
      return (
        <ul className='inventory-attachments-files-list row'>
          {(categoryItemProfile && categoryItemProfile.attachments.length > 0) &&
                categoryItemProfile.attachments.map(file =>
                  <li key={file.fileName}>
                    <div style={{
                      width: 50,
                      height: 60,
                      marginLeft: 15,
                      marginRight: 10,
                      borderRadius: 2,
                      verticalAlign: 'top',
                      backgroundImage: `url(${this.renderFileTypeIcon(file)})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      display: 'inline-block'
                    }} />
                    <div style={{display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '80%', whiteSpace: 'nowrap'}} className='file-info'>
                      <span onDoubleClick={() => this.onPreviewFilesAttachment(file)} >{file.fileName}</span>
                    </div>
                    {/* <div style={{display: 'inline-block'}} className='remove-button-wrapper' onClick={() => this.onRemoveFiles(file.id)}>
                      <div className='remove-button icon-remove-ic' />
                    </div> */}
                  </li>
                )}
        </ul>
      );
    }

    renderInventoryValue = value => {
      if (value) {
        return <Linkify><strong>{value}</strong></Linkify>;
      }
      return <span style={{ opacity: '.5' }}>(Not specified)</span>;
    }

    renderCategoryValue = (categories) => {
      if (!isEmpty(categories)) {
        return <Linkify><strong>{categories[0]}</strong></Linkify>;
      }
      return <span style={{ opacity: '.5' }}>(Not specified)</span>;
    }

    renderInventoryWarrantyValue = profile => {
      if (profile.warrantyExpirationDateValue === null && profile.warrantyExpirationIntValue === null) {
        return <span style={{ opacity: '.5' }}>(Not specified)</span>;
      }
      if (profile.warrantyExpirationDateValue === null) {
        return <strong>{profile.warrantyExpirationIntValue} {profile.warrantyExpirationTimeUnit === 0 ? ((profile.warrantyExpirationIntValue > 1) ? 'months' : 'month') : ((profile.warrantyExpirationIntValue > 1) ? 'years' : 'year')} from {profile.warrantyExpirationType === 0 ? 'COE'
          : 'Purchase Date'
        }</strong>;
      }
      if (profile.warrantyExpirationDateValue !== null) {
        return <strong>{Moment(profile.warrantyExpirationDateValue).format('MM/DD/YYYY')}</strong>;
      }
      return '';
    }

    onCustomAction = () => {
      const {history, location} = this.props;
      const queryParams = queryString.parse(location.search);

      history.push({
        pathname: location.pathname,
        search: queryString.stringify({
          ...queryParams,
          id: null
        })
      });
    }

    onSubmit = (e) => {
      const {lot, categoryItemProfile} = this.props;
      const { builderProfile } = lot.extensionValue;

      e.preventDefault();

      const formValue = this.form.getValues();
      this.props.dispatch({
        type: LotActionType.EDIT_CATEGORY_ITEM_HOMEOWNER_ASYNC,
        params: {
          lotId: lot.value,
          data: {
            id: categoryItemProfile.lot.id,
            serialNumber: formValue.serialNumber,
            serviceFee: formValue.serviceFee,
            purchaseDate: formValue.purchaseDate ? Moment(formValue.purchaseDate).hour(Moment().hour()) : formValue.purchaseDate,
            tagLocations: formValue.location
          },
          builderHost: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback: this.props.goToViewScreen
      });
    }

    onChangeText = (e, type) => {
      this.setState({
        [type]: e.target.value
      });
    }

    onChangeDate = (type, value) => {
      if (value) {
        if (Moment(value, 'MM/DD/YYYY', true).isValid()) {
          this.setState({
            [type]: value,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'DD/MM/YYYY', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'DD/MM/YYYY')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/DD/MM', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/DD/MM')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/MM/DD', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/MM/DD')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else {
          this.setState({
            error: {...this.state.error, [type]: 'Invalid date.'}
          });
        }
      } else {
        this.setState({
          [type]: value,
          error: {...this.state.error, [type]: null}
        });
      }
    }

    onClickBreadcrumb = () => {
      this.props.goToListScreen();
    }

    render() {
      const { imagePreview, purchaseDate} = this.state;
      const {categoryItemProfile} = this.props;
      let listTagsLocation = categoryItemProfile.lot.tagLocations.map(x => x.hiTagLocationId);
      const breadcrumbs = [
        {title: 'Inventory items', url: '/', onCustomAction: this.onClickBreadcrumb},
        {title: `${categoryItemProfile.name}`, url: ''}
      ];

      return (
        <React.Fragment>
          <div className='home-libraries-inventory container-fluid'>
            <h4 style={{ height: 30, marginTop: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{categoryItemProfile.name}</h4>
            <div><Breadcrumb breadcrumbs={breadcrumbs} /></div>
            {
              this.state.isPreviewPDF && !isMobile && [
                <embed src={this.state.isPreviewPDF} className='pdf-preview-dialog' ref={ref => {this.embedPreview = ref;}} />,
                <i onClick={() => this.setState({isPreviewPDF: null})} className='close-embed-preview fa fa-close' />
              ]
            }
            {
              <PreviewImage
                show={this.state.show}
                imageUrl={this.state.previewUrl}
                handleClose={this.handleClose}
              />
            }
            {
              this.state.videoUrl && [
                <PreviewVideoWO
                  // loading
                  data={this.state.videoUrl}
                  showDialog={this.state.showDialog}
                  handleCloseVideo={this.handleCloseVideo}
                />
              ]
            }
            <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit}>
              <div className='add-new-category-item row'>
                <div className='col-md-6 col-xs-6'>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Name</label>
                      <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          categoryItemProfile.name ? categoryItemProfile.name : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Inventory</label>
                      <div className=' col-sm-9 control-label name form-text-label'>
                        {this.renderCategoryValue(
                          categoryItemProfile.categories ? categoryItemProfile.categories : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>MFG/Provider</label>
                      <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          categoryItemProfile.mfg ? categoryItemProfile.mfg : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Model/Type</label>
                      <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          categoryItemProfile.model ? categoryItemProfile.model : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>MFG Links</label>
                      <div style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}} className='col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          categoryItemProfile.note ? categoryItemProfile.note : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Style</label>
                      <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryValue(
                          categoryItemProfile.style ? categoryItemProfile.style : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Serial number</label>
                      <div className='margin-left-10 col-sm-12'>
                        <Input
                          name='serialNumber'
                          ref='serialNumber'
                          className='form-control'
                          autoFocus
                          value={categoryItemProfile.lot.serialNumber}
                          max='254'
                          maxLength='254'
                          validations={[validator.maxlength]} />
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Price/Service fee</label>
                      <div className='margin-left-10 col-sm-12' style={{position: 'relative'}} >
                        <span style={{top: 10, left: 15, position: 'absolute'}}>$</span>
                        <Input
                          style={{paddingLeft: 20}}
                          name='serviceFee'
                          type='number'
                          ref='serviceFee'
                          className='form-control'
                          autoFocus
                          value={categoryItemProfile.lot.serviceFee ? categoryItemProfile.lot.serviceFee.toString() : ''}
                          min={0}
                          maxDigit={17}
                          maxDecimalDigit={2}
                          validations={[validator.isPositiveFloatDecimal]} />
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Purchase date</label>
                      <div className='margin-left-10 col-sm-12'>
                        <DatePicker
                          ref='purchaseDate'
                          name='purchaseDate'
                          value={!isNull(categoryItemProfile.lot.purchaseDate) ? Moment(categoryItemProfile.lot.purchaseDate).format('MM/DD/YYYY') : purchaseDate} />
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Locations</label>
                      <div className='margin-left-10 col-sm-12'>
                        <TagsInputs
                          ref='location'
                          name='location'
                          className='tag-input-lot-installed form-control'
                          value={listTagsLocation}
                          addKeys={TAGS_LIST}
                          onlyUnique={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='view-details'>
                    <div className='row col-sm-12 margin-bottom-20'>
                      <label className='col-sm-3 font-normal control-label'>Limited warranty period</label>
                      <div className='col-sm-9 control-label name form-text-label'>
                        {this.renderInventoryWarrantyValue(
                          categoryItemProfile ? categoryItemProfile : null
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={{margin: '15% 0 10%'}} className='row'>
                    <div className='col-sm-6 col-xs-12'>
                      <span className='btn btn-siteone-default' onClick={this.props.goToViewScreen}>Cancel</span>
                      <Submit className='btn btn-primary btn-siteone'>Save</Submit>
                    </div>
                  </div>
                </div>

                <div style={{marginTop: -115}} className='col-md-6 col-xs-6'>
                  <div className='preview-inventory-items-image'>
                    <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-md-12 col-xs-12'>
                          {imagePreview && <img
                            className='empty-category-image'
                            src={imagePreview || !isEmpty(categoryItemProfile.images) ? imagePreview : emptyImages}
                            alt='no-files'
                          />}
                          { !imagePreview && <img
                            className='empty-category-image'
                            src={categoryItemProfile && categoryItemProfile.images.length ? categoryItemProfile.images[0].url : emptyImages}
                            alt='no-files'
                          />}
                        </div>
                      </div>
                    </div>

                    <div className='container-fluid'>
                      <div className='list-thumbnail-image-after-upload'>
                        <div className='row'>
                          {/* map img FIXME:*/}
                          <div style={{height: 70, display: 'flex', justifyContent: 'center'}} className='col-md-12 col-sm-6 col-xs-12'>
                            {!isEmpty(categoryItemProfile.images) && (
                              categoryItemProfile.images.map((el, index) => {
                                return (
                                  <div key={index} className='image-file-after-upload col-md-2 col-xs-4 col-lg-2'>
                                    <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* attachments */}
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <label className='font-normal'>
                            Attachments
                      </label>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <div style={{marginLeft: -20}} className='inventory-attachments-files-list container-fluid'>
                        {(categoryItemProfile && categoryItemProfile.attachments && categoryItemProfile.attachments.length) ? this.renderFileUpload() : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </React.Fragment>
      );
    }

}

const mapStateToProps = (state) => {
  return {
    categoryList: state.LotStore.categoryList,
    categoryItemProfile: state.LotStore.categoryItemProfile
  };
};

export default withRouter(connect(mapStateToProps)(EditCategoryItemsLot));



// WEBPACK FOOTER //
// ./src/Lots/Components/Inventory/item-edit.js